import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { ApplicantService } from 'src/app/services/applicant.service';
import { CoApplicantService } from 'src/app/services/co-applicant.service';
import { QuestionService } from 'src/app/services/question.service';
import { TosterService } from 'src/app/services/toster.service';
@Component({
  selector: 'app-assess-checklist',
  templateUrl: './assess-checklist.component.html',
  styleUrls: ['./assess-checklist.component.css'],
})
export class AssessChecklistComponent implements OnInit {
  applicant_id: any;
  section: any[] = [];
  copyToggleChecked = false;
  criteria: any;
  app_email: any;
  questions: any;
  floating: boolean = false;
  subsection: any;
  subsecs: any;
  answer: any;
  checkminmax: boolean = true;
  Sectionform!: FormGroup;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  public model: any = {};
  modall: any = [];
  public modelscore: any = {};
  public modelscorestatus: any = {};
  modallscore: any = [];
  udata: any;
  section_no: any;
  allocated_id: any;
  cosection: any[] = [];
  cosubsecs: any = [];
  activeTab: string = 'applicant';
  activeSubsection: string = '';
  currcriteria: string = '';
  siteIssue: any = {};
  siteIssues: any = {};
  headers: any = {
    'Criteria 1': {
      A: 'General Regulatory Requirements',
      B: 'Food Safety Practices',
    },
    'Criteria 11': {
      A: 'Statutory, Regulatory and Social Compliance',
      B: 'Laboratory Management',
      C: 'Leadership and Best Practices in Laboratory Initiatives',
    },
    'Criteria 2A for SMB': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Food counters and Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Display of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Eating facilities for Customers',
      '18': 'People, Competence & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Cont Imp, System, Tools and Techniques',
      '21': 'Recognition of People',
      '22': 'Canteen Management in Food Safety and Sustainability',
      '23': 'Food Takeaways/ Food Delivery',
      '24': 'Food Defence',
      '25': 'Food Loss - Food Waste',
      '26': 'Internal Checks/ Internal Audits'
    },
    'Criteria 2A Large': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Food counters and Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Display of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Eating facilities for Customers',
      '18': 'People, Competence & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Cont Imp, System, Tools and Techniques',
      '21': 'Recognition of People',
      '22': 'Canteen Management in Food Safety and Sustainability',
      '23': 'Food Takeaways/ Food Delivery',
      '24': 'Food Defence',
      '25': 'Food Loss - Food Waste',
      '26': 'Internal Checks/ Internal Audits'
    },
    'Criteria 2B for SMB': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Management of Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Delivery of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Delivery Containers , Personnel & Transport',
      '18': 'People, Competence, Culture & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Continual Improvement System, Tools and Techniques',
      '21': 'Recognition of People'
    },
    'Criteria 2B Large': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Management of Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Delivery of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Delivery Containers , Personnel & Transport',
      '18': 'People, Competence, Culture & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Continual Improvement System, Tools and Techniques',
      '21': 'Recognition of People'
    },
    'Criteria 2 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A1 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A1 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A2 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A2 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 4': {
      A: 'Social & Regulatory Requirement',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 5': [],
    'Criteria 7': {
      A: 'Self-Declaration',
      B4: 'Management of Partnerships',
    },
    'Criteria 9': {
      A: 'Statutory & Regulatory Requirements & Social Compliance',
      B1: 'Pre Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Good Manufacturing Practices (GMP)',
      D: 'Change Management Initiatives'
    },
  }

  constructor(
    private router: Router,
    private quest: QuestionService,
    private applicant: ApplicantService,
    private _Activatedroute: ActivatedRoute,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private toast: TosterService,
    private coapp: CoApplicantService
  ) { }
  ngOnInit(): void {
    this.spinner.show();
    this.udata = localStorage.getItem('userdata');
    this.udata = JSON.parse(this.udata);
    let email = this.udata.email;
    this.applicant_id = this._Activatedroute.snapshot.paramMap.get('id');
    this.allocated_id = this._Activatedroute.snapshot.paramMap.get('_id');
    this.applicant
      .GetAdminApplicantSingle(this.applicant_id)
      .subscribe((data: any) => {
        if (
          data.applicanData[0].criteria != '' &&
          data.applicanData[0].userStatus === true
        ) {
          console.log([data.applicanData[0].criteria]);
          this.criteria = [data.applicanData[0].criteria];
          this.currcriteria = data.applicanData[0].criteria;
          this.app_email = data.applicanData[0].email;
          this.quest
            .getAllocated({
              allocation_id: this.allocated_id,
              assessor_id: this.udata._id,
            })
            .subscribe((elem: any) => {
              this.section = elem[0].section;
              this.subsecs = elem[0].sub_section;
              this.cosection = elem[0].cosection;
              this.cosubsecs = elem[0].cosub_section;
              this.section = this.section.sort();
              this.subsecs = this.subsecs.sort();
              if (this.cosection) this.cosection = this.cosection.sort();
              if (this.cosubsecs) this.cosubsecs = this.cosubsecs.sort();
              this.coapp.listCoApplicant(data.applicanData[0]._id).subscribe((resp: any) => {
                if (resp.result.length) {
                  let criterias = resp.result[0].co_criteria;
                  this.criteria = this.criteria.concat(criterias);
                  console.log(this.criteria);
                }
                this.spinner.hide();
              });
            });
        } else {
        }
        this.dtTrigger.next();
      });
  }
  formInit(model: any) {
    this.Sectionform = this.fb.group(model);
  }
  public get f() {
    return this.Sectionform.controls;
  }
  checkAllValid() {
    for(const [key, value] of Object.entries(this.siteIssue)) {
      if(value && !this.siteIssues[key]) {
        this.toast.showError('Please enter site issue feedback for all checked items.');
        return false;
      }
    }
    return true;
  }
  onSubmit() {
    const isValid = this.checkAllValid();
    if(!isValid) {
      return;
    }
    this.spinner.show();
    let criteria = this.criteria[0]
    if (this.activeTab == 'coapplicant') {
      criteria = this.criteria[1];
    }
    this.Sectionform.patchValue(this.modall);
    this.quest
      .saveAssessment({
        assessment: Object.keys(this.Sectionform.value)?.length ? this.Sectionform.value : this.modall,
        section_no: this.section_no,
        email: this.udata.email,
        applicant_id: this.applicant_id,
        criteria: criteria,
        type: this.udata.role,
        copiedApplicant: this.copyToggleChecked,
        siteIssues: this.siteIssues,
        siteIssue: this.siteIssue,
      })
      .subscribe({
        next: (item: any) => {
          this.quest
            .addScore({
              assessment_id: item.assessment._id,
              allocation_id: this.allocated_id,
              applicant_id: this.applicant_id,
              assessor_id: this.udata._id,
              criteria: criteria,
              score: this.modelscore,
              applicable: this.modelscorestatus,
             questionWiseScore: this.modelQuestionWiseScore,
              scoreBy: this.udata.email,
            })
            .subscribe({
              next: (itemRes: any) => {
                this.toast.showInfo('Section Saved.');
                this.spinner.hide();
              },
              error: (err: any) => {
                this.spinner.hide();
              }
            });
        },
        error: (err: any) => {
          this.spinner.hide();
        }
      });
  }
  switchTab(userType: any) {
    this.activeTab = userType;
    this.floating = false
    this.model = {};
    this.modelscore = {};
      this.modelQuestionWiseScore = {};
    this.section_no = NaN;
    this.modelscorestatus = {};
    this.subsection = [];
    this.copyToggleChecked = false;
    this.activeSubsection = '';
    this.currcriteria = this.criteria[0]
    if (this.activeTab == 'coapplicant') {
      this.currcriteria = this.criteria[1]
    }
  }
  modelQuestionWiseScore :any = {};
  getQuestion(sec: any) {
    let criteria = this.criteria[0];
    if (this.activeTab == 'coapplicant') {
      criteria = this.criteria[1];
    }
    this.floating = false
    this.model = {};
    this.modelscore = {};
    this.modelQuestionWiseScore = {};
    this.section_no = sec;
    this.activeSubsection = sec;
    this.modelscorestatus = {};
    this.subsection = [];
    this.spinner.show();
    this.quest
      .viewQuestionByCriteria({
        criteria: criteria,
        section_no: sec,
      })
      .subscribe((itemQues: any) => {
        itemQues.sec.map((element: any) => {
          if (this.subsecs.includes(element?.sub_section_no)) {
            this.model[element?._id] = '';
            this.modelscore[element?.sub_section_no] = 0;
           
            this.modelscorestatus[element?.sub_section_no] = false;
          }
        });
        console.log(itemQues);
        this.quest
          .viewAssessment({
            section_no: this.section_no,
            email: this.udata.email,
            criteria: criteria,
            type: this.udata.role,
            applicant_id: this.applicant_id
          })
          .subscribe(async (ele: any) => {
            this.copyToggleChecked = false
            if (ele.ass.length) {
              this.copyToggleChecked = ele.ass[0].copiedApplicant
              this.modall = await ele.ass[0].assessment[0];
              this.siteIssues = ele.ass[0].siteIssues || {};
              this.siteIssue = ele.ass[0].siteIssue || {};
              this.Sectionform = this.fb.group(this.modall);
              this.Sectionform.patchValue(this.modall)
              this.quest
                .getScore({
                  assessment_id: ele.ass[0]._id,
                })
                .subscribe((itemScore: any) => {
                  this.modelscore = itemScore[0]?.score[0];
                  console.log(itemScore);
                   this.modelQuestionWiseScore = itemScore[0]?.questionWiseScore[0] || {};
                   console.log("this.modelQuestionWiseScore:  ",this.modelQuestionWiseScore);
                  this.modelscorestatus = itemScore[0]?.applicable
                    ? itemScore[0]?.applicable[0]
                    : this.modelscorestatus;
                  this.formInit(this.model);
                });
            } else {
              this.formInit(this.model);
            }
          });
        this.quest
          .viewAssessment({
            section_no: sec,
            email: this.app_email,
            criteria: criteria,
            type: 'applicant',
          })
          .subscribe(async (ele: any) => {
            if (ele.ass.length) {
              this.answer = ele.ass[0].assessment[0];
              this.questions = itemQues.sec;
              this.questions.map((items: any) => {
                if (this.answer.hasOwnProperty(items._id)) {
                  items.answer = this.answer[items._id];
                }
              });
              this.floating = true
              this.subsection = this.removeDuplicateObjectFromArray(
                this.questions,
                'sub_section_no'
              );
            } else {
              alert('No Data found');
            }
            this.spinner.hide();
          });
      });
  }
  onChangeControl(id: any, e: any, chk: any) {
    this.Sectionform.addControl(id, new FormControl(''));
    this.Sectionform.controls[id].setValue(chk == null ? e.target.value : e);
  }
  onChangeScore(id: any, e: any, chk: any) {
    if (e.target.value > 95) {
      this.modelscore[id] = 95
    } else if (e.target.value < 5) {
      this.modelscore[id] = 5
    } else
      this.modelscore[id] = chk == null ? Math.round(e.target.value / 5) * 5 : e;
  }

   onChangeQuestionScore(id: any, e: any, chk: any) {
    console.log("Data: ",id,"  :  ",e.target.value);
    if (e.target.value > 95) {
      this.modelQuestionWiseScore[id] = 95
    } else if (e.target.value < 5) {
      this.modelQuestionWiseScore[id] = 5
    } else
      this.modelQuestionWiseScore[id] = chk == null ? Math.round(e.target.value / 5) * 5 : e;
  }

  validateScore(item_inner: any): void {
  const val = item_inner.score;
  if (val % 5 !== 0) {
    // Reset or round to nearest multiple
    item_inner.score = Math.round(val / 5) * 5;
  }
}


  isInputInvalid(subSectionNo: number): boolean {
    const score = this.modelscore[subSectionNo];
    var test = (score < 5 || score > 95) && score != null;
    this.checkminmax = test;
    return test;
  }

  isScoreInvalid(score: number): boolean {
  return  (score < 5 || score > 95 || score % 5 !== 0);
}

  removeDuplicateObjectFromArray(array: any, key: any) {
    return array.filter(
      (obj: any, index: any, self: any) =>
        index === self.findIndex((el: any) => el[key] === obj[key])
    );
  }
  checkModelScoreValidity(): boolean {
    for (const key in this.modelscore) {
      if (this.modelscore.hasOwnProperty(key)) {
        const score = this.modelscore[key];
        if ((score < 5 || score > 95) && (score != null)) {
          return false; // Invalid score found
        }
      }
    }
    return true; // All scores are valid
  }
  getNotApplicable(e: any, sub_section_no: any) {
    this.modelscorestatus[sub_section_no] = !e.target?.checked;
    this.modelscore[sub_section_no] = 'N/A';
  }
  setSiteIssue(e: any, sub_section_no: any) {
    if(e.target?.checked) {
      this.siteIssue[sub_section_no] = true;
    } else {
      this.siteIssue[sub_section_no] = false;
      delete this.siteIssues[sub_section_no];
    }
  }
  
  onChangeSiteIssue(sub_section_no: any, e: any) { 
    this.siteIssues[sub_section_no] = this.siteIssue[sub_section_no] ? e.target.value : "";
  }

  isSiteIssueInvalid(sub_section_no: any): boolean {
    return this.siteIssue[sub_section_no] && !this.siteIssues[sub_section_no];
  }

  onCopyValueClick(checked: any, item: any) {
    this.copyToggleChecked = checked
    if (checked) {
      for (let item_inner of item.questions) {
        const targetInput = document.getElementById('copyField_' + item_inner?._id) as HTMLInputElement;
        if (targetInput) {
          targetInput.value = item_inner.answer;
          this.modall[item_inner?._id] = item_inner.answer;
        }
      }
    }
    else {
      for (let item_inner of item.questions) {
        const targetInput = document.getElementById('copyField_' + item_inner?._id) as HTMLInputElement;
        if (targetInput) {
          targetInput.value = '';
          this.modall[item_inner?._id] = '';
        }
      }
    }
    this.Sectionform.patchValue(this.modall);
  }
}
